import type { CreateIngestionKeyPayload, NewIngestionKeyResult } from '@jums-dashboard/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { callFunction } from '@/lib/callableClient';

import { ingestionSourcesQueryKey } from './useIngestionSources';

export default function useCreateIngestionKey() {
  const qc = useQueryClient();
  return useMutation<NewIngestionKeyResult, Error, CreateIngestionKeyPayload>({
    mutationFn: (payload) => callFunction<CreateIngestionKeyPayload, NewIngestionKeyResult>('createIngestionKeyCallable', payload),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({ queryKey: ingestionSourcesQueryKey(vars.homeId) });
    },
    onError: (err) => {
      toast.error(err.message || 'Failed to create ingestion key.');
    },
  });
}
